export default __webpack_public_path__ + "justhatched-screens@2x.7966b756.png";